import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LocationsList from '../../components/locations-list/locations-list.component';
import Pay from '../pay/pay.view';
import { Charge } from '../charge/charge.view';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import queryString from 'query-string';
import { LocationWrapper } from '../../components/location/LocationWrapper';
import { ModalWithNavigation } from '../set-up/ModalWithNavigation';
import { ConnectorModal } from '../set-up/ConnectorModal';
import { PhoneModal } from '../set-up/PhoneModal/PhoneModal';
import PrivacyPolicy from '../privacy-policy/privacy-policy';
import TermsOfOffer from '../terms-offer/terms-offer';
import { LegacyStationConnectorRedirect } from './LegacyStationConnectorRedirect';
import { LegacyLocationConnectorRedirect } from './LegacyLocationConnectorRedirect';

const Routing = () => {
    return (
        <QueryParamProvider
            adapter={ReactRouter6Adapter}
            options={{
                searchStringToObject: queryString.parse,
                objectToSearchString: queryString.stringify,
            }}>
            <Routes>
                <Route path="/" element={<LocationsList />} />
                <Route
                    path="/direct/locations/:locationId/:stationId/:connectorId/*"
                    element={<LegacyLocationConnectorRedirect />}
                />
                <Route
                    path="/locations/:locationId/:stationId/:connectorId/*"
                    element={<LegacyLocationConnectorRedirect />}
                />
                <Route path="/direct/locations/:locationId" element={<LocationWrapper />} />
                <Route path="/locations/:locationId" element={<LocationWrapper />} />
                <Route path="/charge/:guestId" element={<Charge />} />
                <Route path="/pay/:guestId" element={<Pay />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-offer" element={<TermsOfOffer />} />
                <Route path="/stations/stations/*" element={<Navigate replace to="/" />} />
                <Route path="/stations/:stationId/:connectorId" element={<ModalWithNavigation />}>
                    <Route index element={<ConnectorModal />} />
                    <Route path="confirm-details" element={<PhoneModal />} />
                </Route>
                <Route path="/:stationId/:connectorId/*" element={<LegacyStationConnectorRedirect />} />
                <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
        </QueryParamProvider>
    );
};

export default Routing;
